var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('substrate-mount', {
    attrs: {
      "show-tail": ""
    }
  }, [_c('div', {
    class: _vm.$style.title
  }, [_vm._v(" " + _vm._s(_vm.$t('report.parameters')) + " ")]), _c('div', {
    class: _vm.$style.panel
  }, [_vm.isTransactionReport ? _c('selectabling-panel', {
    attrs: {
      "label": _vm.$t('transactions.type')
    },
    on: {
      "click": _vm.handleTransactionTypes
    },
    model: {
      value: _vm.panel.transactionTypes,
      callback: function callback($$v) {
        _vm.$set(_vm.panel, "transactionTypes", $$v);
      },
      expression: "panel.transactionTypes"
    }
  }) : _vm._e(), _c('div', {
    class: _vm.$style.tooltip
  }, [_c('report-tooltip', {
    attrs: {
      "message": _vm.tooltip.transactionTypes
    }
  })], 1)], 1), _vm.isTransactionReport ? _c('selectabling-panel', {
    attrs: {
      "label": _vm.$t('transactions.status')
    },
    on: {
      "click": _vm.handleTransactionStatuses
    },
    model: {
      value: _vm.panel.transactionStatuses,
      callback: function callback($$v) {
        _vm.$set(_vm.panel, "transactionStatuses", $$v);
      },
      expression: "panel.transactionStatuses"
    }
  }) : _vm._e(), _c('div', {
    class: _vm.$style.panel
  }, [_vm.isPartnerReport ? _c('selectabling-panel', {
    attrs: {
      "label": _vm.$t('common.partners')
    },
    on: {
      "click": _vm.handlePartners
    },
    model: {
      value: _vm.panel.partners,
      callback: function callback($$v) {
        _vm.$set(_vm.panel, "partners", $$v);
      },
      expression: "panel.partners"
    }
  }) : _vm._e(), _c('div', {
    class: _vm.$style.tooltip
  }, [_c('report-tooltip', {
    attrs: {
      "message": _vm.tooltip.partners
    }
  })], 1)], 1), _vm._t("period"), _c('div', {
    class: _vm.$style.panel
  }, [_c('selectabling-panel', {
    attrs: {
      "label": _vm.$t('common.info')
    },
    on: {
      "click": _vm.handleMetrics
    },
    model: {
      value: _vm.panel.metrics,
      callback: function callback($$v) {
        _vm.$set(_vm.panel, "metrics", $$v);
      },
      expression: "panel.metrics"
    }
  }), _c('div', {
    class: _vm.$style.tooltip
  }, [_c('report-tooltip', {
    attrs: {
      "message": _vm.tooltip.metrics
    }
  })], 1)], 1)], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }